export default () => ({
  root: {
    width: '500px',
    height: '200px',
  },
  loader: {
    display: 'flex',
    justifyContent: 'center',
  },
});
